module.exports = __webpack_public_path__ + "static/scale-model-of-columbia-audubon-nature-sanctuary-in-columbia-missouri-4472a92a2a0c536ee86d243026efb6be.png";